import { graphql, useStaticQuery } from 'gatsby';

const useSectionImages = () => {
  const { allContentfulImage } = useStaticQuery(graphql`
    query {
      allContentfulImage(
        filter: {
          contentful_id: {
            in: [
              "53fbM8YaeJgrfzFGHNPtii" #Background blue-dark-corner-right
              "4dNX38bytUN3Jv2w54zbJR" #Background blue-light-corner-right
              "2hvG4QN0NKLjQRKB23B58i" #Background blue-light-side-right
              "3T6T5wlGUtSTCTKiWfmfkh" #Background blue-dark-corner-left
            ]
          }
        }
      ) {
        edges {
          node {
            internalName
            image {
              file {
                url
              }
            }
          }
        }
      }
    }
  `);

  return allContentfulImage;
};

export default useSectionImages;
